import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Alert = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke={props.color || theme.colors.grey700}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 10V6m9-5H3a2 2 0 00-2 2v13a2 2 0 002 2h5l4 5 4-5h5a2 2 0 002-2V3a2 2 0 00-2-2zm-9 12v-.01"
        ></path>
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path d="M22.001.001h-20a2 2 0 00-2 2v15a2 2 0 002 2h6l4 5 4-5h6a2 2 0 002-2v-15a2 2 0 00-2-2zm-11 5a1 1 0 012 0v5a1 1 0 01-2 0v-5zm1 11A1.5 1.5 0 1112.002 13a1.5 1.5 0 01-.001 3z"></path>
    </svg>
  );
};
